import * as React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import "./index.scss";

class Navigation extends React.Component {
  render() {
    const { sidebarVisible, children, companyName, companyNameTooltip } = this.props;
    return (
      <>
        <div className={sidebarVisible ? "second-sidenav" : "second-sidenav second-sidenav-16"}>
          <div className="company-name">
            <Tooltip title={companyNameTooltip}>
              <span>{companyName}</span>
            </Tooltip>
          </div>

          <div className="sidenav-menu">{children}</div>
        </div>
      </>
    );
  }
}
export default Navigation;
